import type { PermissionEnum } from '@shared/api';
import { PERMISSION_COLORS } from '@shared/constants';
import { User } from '@shared/ui/user';
import type { UserProps } from '@shared/ui/user/user';
import { type FC, type TdHTMLAttributes, useContext } from 'react';

import { TableContext } from '../table-context';

export type TCellUserProps = TdHTMLAttributes<HTMLTableCellElement> & {
  index?: number;
  city?: string;
  user: UserProps;
  permission?: PermissionEnum;
};

export const TCellUser: FC<TCellUserProps> = ({ user, city, index, permission, ...props }) => {
  const { columnsConfiguration } = useContext(TableContext);

  const column = index === undefined ? null : columnsConfiguration[index];
  const width = column?.width;
  const avatarBackgroundColor = permission ? PERMISSION_COLORS[permission] : undefined;

  return (
    <td style={{ width }} {...props}>
      <User
        size="sm"
        avatar={user.avatar}
        fullName={user.fullName}
        caption={user.caption}
        avatarBackgroundColor={avatarBackgroundColor}
      />
    </td>
  );
};
